import { apiGetProduct, apiGetProducts, apiGetVariationImages } from 'api/products';
import * as ActionType from './actionType';

export const fetchGetProducts = (params) => async (dispatch, getState) => {
  try {
    const response = await apiGetProducts({ params });
    const { data: { products, pagination } } = response;
    const actionPayload = { productsData: products, pagination };

    dispatch({
      type: ActionType.FETCH_GET_PRODUCTS,
      payload: actionPayload,
    });

    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error.response.data.message);
  }
};

export const fetchGetSingleProduct = (payload) => async (dispatch) => {
  const { productId } = payload;
  try {
    const response = await apiGetProduct({ productId });
    const { data: { product } } = response;
    const actionPayload = { selectedProduct: product };
    dispatch({
      type: ActionType.SAVE_SELECT_PRODUCT,
      payload: actionPayload,
    });
    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error.response.data.message);
  }
};

export const fetchSearchProducts = () => {

};

export const fetchGetVariationImages = (payload) => async (dispatch, getState) => {
  const { products: { selectedProduct, selectedVariation } } = getState();
  const selectedProductId = selectedProduct._id;
  const variationId = selectedVariation._id;
  try {
    const response = await apiGetVariationImages(
      { productId: selectedProductId, params: { variation_id: variationId } },
    );
    const { data: { variationImages } } = response;
    const actionPayload = { variationImages };

    dispatch({
      type: ActionType.FETCH_GET_VARIATION_IMAGES,
      payload: actionPayload,
    });
    return Promise.resolve();
  } catch (error) {
    return Promise.reject(error.response.data.message);
  }
};

export const selectProduct = (payload) => ({
  type: ActionType.SELECT_PRODUCT,
  payload,
});

export const selectVariation = (payload) => ({
  type: ActionType.SELECT_VARIATION,
  payload,
});
